import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchBrandingState } from "../../lib/branding";

// Report branding is server data with a localStorage fallback inside fetchBrandingState.
// One query so the section-180 card and the branding dialog read the same copy.
export const brandingKey = (orgId: string) => ["branding", orgId] as const;

export function useBranding(orgId: string | null) {
  const id = orgId ?? "";
  return useQuery({
    queryKey: brandingKey(id),
    queryFn: () => fetchBrandingState(id),
    placeholderData: keepPreviousData,
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
